import { render, staticRenderFns } from "./NavigationSidebarFree.vue?vue&type=template&id=01e366bd&scoped=true&"
import script from "./NavigationSidebarFree.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebarFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e366bd",
  null
  
)

export default component.exports